import { JourneyLayout } from "@/components/journey/JourneyLayout";
import { VerseDisplay } from "@/components/journey/VerseDisplay";
import { joyVerses } from "@/data/verses";

export default function JourneyJoy() {
  return (
    <JourneyLayout title="Joy">
      <VerseDisplay verses={joyVerses} />
    </JourneyLayout>
  );
}